import styled from '@emotion/styled';
import { useSmartGuides } from '../../context/SmartGuidesProvider';
import { PrintableBody2 } from '../../printable-styles/printable-typography';
import { MediaType } from '../../types/Media';
import { PartType } from '../../types/smart-guide';
import { TableContentType } from '../../types/Table';
import { Accordion } from '../Accordion';
import { Media } from '../Media';
import { PreprInnerHtml } from '../PreprInnerHtml';
import { Table } from '../Table';

type Props = {
  children: string;
  part?: PartType;
  media?: MediaType[] | null;
  isPrintable?: boolean;
  tables?: TableContentType[];
};

const StyledSolution = styled(PrintableBody2)`
  color: ${({ theme }) => theme.tokens.color.alias.cm.text.text.value};
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media print {
    color: #000000;
  }
`;

export function Solution({
  children,
  part,
  media,
  isPrintable,
  tables,
}: Props): JSX.Element {
  const { t } = useSmartGuides();

  const hasTable = tables?.length && tables.length > 0;

  return (
    <Accordion
      summary={t('digitalguides.solution')}
      hasPreview
      part={part}
      isPrintable={isPrintable}
    >
      <StyledSolution>
        <PreprInnerHtml text={children} />
        {media && <Media media={media} />}
        {hasTable && <Table tables={tables} part={part} />}
      </StyledSolution>
    </Accordion>
  );
}
